import logDrtEvent from '../lib/logging';

async function callApiPost(url, data, headers = { "Content-Type": "application/json" }) {
    return fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data),
    });
}

async function callApiGet(url, headers = { "Content-Type": "application/json" }, params = {}) {
    const urlParams = new URLSearchParams(params);
    return fetch(url + "?" + urlParams.toString(), {
        method: "GET",
        headers: headers,
    });
}

async function callBackendApiPost(url, data, token = null) {
    const headers = {
        "Content-Type": "application/json",
        "X-API-KEY": process.env.REACT_APP_X_API_KEY,
    };

    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }

    return fetch(process.env.REACT_APP_BACKEND + url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data),
    });
}

async function callBackendApiPostFormData(url, data, token = null) {
    const headers = {
        "X-API-KEY": process.env.REACT_APP_X_API_KEY,
    };

    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 120_000);

    try {
        const response = await fetch(process.env.REACT_APP_BACKEND + url, {
            method: "POST",
            headers: headers,
            body: data,
            signal: controller.signal,
        });
        return response;
    }
    finally {
        clearTimeout(timeoutId);
    }
}

async function callBackendApiGet(url, params = {}, token = null) {
    const urlParams = new URLSearchParams(params);

    const headers = {
        "Content-Type": "application/json",
        "X-API-KEY": process.env.REACT_APP_X_API_KEY,
    };

    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }

    return fetch(process.env.REACT_APP_BACKEND + url + (urlParams.toString() ? "?" + urlParams.toString() : ""), {
        method: "GET",
        headers: headers,
    });
}

async function alertOps(user, errorType, errorMessage, errorLocation) {
    try {
        const alertData = {
            fname: user.firstName,
            lname: user.lastName,
            phone: user.phoneNo,
            email: user.email,
            error_message: `Submission error type: ${errorType}; error message: ${errorMessage}`,
            error_location: errorLocation
        };

        await callBackendApiPost("/api/v1/alert_ops", alertData);
    } catch (error) {
        logDrtEvent("Failed to alert operations: " + error);
    }
}

export { callApiPost, callApiGet, callBackendApiPost, callBackendApiPostFormData, callBackendApiGet, alertOps };
